/**
 * Opens Intercom messenger with an optional message.
 */
export const showMessage = (message = '') => {
  if (window.Intercom) {
    window.Intercom('showNewMessage', message);
  }
};

/**
 * Sends user events to Intercom.
 */
export const trackEvent = (eventName: string, metadata: Record<string, unknown> = {}) => {
  if (window.Intercom) {
    window.Intercom('trackEvent', eventName, metadata);
  }
};

/**
 * Updates Intercom with user data.
 */
export const update = (userData: Record<string, unknown> = {}) => {
  if (window.Intercom) {
    window.Intercom('update', userData);
  }
};
